/* HUSHLY KIDS — en-tete qui se cache en descente et revient en remontee.
   Machine a deux etats, calquee sur gruns.co :
     hkh-past   : posee des qu'on a depasse la hauteur de l'en-tete d'origine ;
     hkh-hidden : ajoutee quand on DESCEND, retiree quand on MONTE.
   Le fichier n'est servi que si le reglage « sticky_hide_on_scroll » est coche :
   decoche, rien n'est charge et l'en-tete redevient celui d'avant. */
(function () {
  'use strict';
  /* on ne change pas d'avis sur du bruit : il faut ce mouvement, en pixels,
     pour decider d'un sens. Sans ce plancher, le rebond du defilement fait
     clignoter la barre. */
  var SEUIL = 6;

  function init() {
    var sec = document.querySelector('.section-header');
    if (!sec || sec.getAttribute('data-hkh') === '1') return;
    /* l'en-tete de Dawn a son propre mode collant : s'il est allume, on ne
       pose rien par-dessus. */
    if (sec.querySelector('sticky-header')) return;
    sec.setAttribute('data-hkh', '1');

    var past = false;
    var hidden = false;
    var last = window.pageYOffset || document.documentElement.scrollTop || 0;
    var pending = false;
    /* Le bandeau d'annonce se replie des qu'on defile (body.hg-scrolled). La page
       raccourcit alors de sa hauteur AU-DESSUS de l'ecran, et l'ancrage de
       defilement de Chrome compense en remontant la position : mesure du 10/09,
       un defilement de 600 px vers le bas finit a y 529, soit 71 px de mouvement
       vers le haut que personne n'a demandes, et la barre se remontrait au lieu
       de se cacher. On suit donc la hauteur du bandeau et on decale la reference
       d'autant : ce repli n'est pas un mouvement du lecteur. */
    var banniere = document.querySelector('.hg-ann');
    if (banniere) banniere = banniere.closest('.shopify-section') || banniere;
    var hautBanniere = banniere ? banniere.offsetHeight : 0;

    /* premiere pose sans animation, puis on rend la transition */
    sec.classList.add('hkh-noanim', 'hkh');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { sec.classList.remove('hkh-noanim'); });
    });

    function hauteur() { return sec.offsetHeight || 0; }

    function tick() {
      pending = false;
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      var h = hauteur();

      /* haut de page : etat de repos, rien n'est pose */
      if (y <= h) {
        if (past) { past = false; sec.classList.remove('hkh-past'); }
        if (hidden) { hidden = false; sec.classList.remove('hkh-hidden'); }
        last = y;
        return;
      }

      if (!past) { past = true; sec.classList.add('hkh-past'); }

      if (banniere) {
        var hb = banniere.offsetHeight;
        if (hb !== hautBanniere) { last -= (hautBanniere - hb); hautBanniere = hb; }
      }

      var d = y - last;
      if (d > SEUIL) {
        if (!hidden) { hidden = true; sec.classList.add('hkh-hidden'); }
        last = y;
      } else if (d < -SEUIL) {
        if (hidden) { hidden = false; sec.classList.remove('hkh-hidden'); }
        last = y;
      }
    }

    function auDefilement() {
      if (pending) return;
      pending = true;
      requestAnimationFrame(tick);
    }

    addEventListener('scroll', auDefilement, { passive: true });
    addEventListener('resize', auDefilement);
    /* le bandeau d'annonce se replie en 0,32 s : la hauteur de reference change
       pendant ce temps, on repasse une fois la transition finie. */
    addEventListener('transitionend', auDefilement);
    tick();
  }

  if (document.readyState === 'loading') addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
